import { render, staticRenderFns } from "./changepwd.vue?vue&type=template&id=35cd9e82&scoped=true&"
import script from "./changepwd.vue?vue&type=script&lang=js&"
export * from "./changepwd.vue?vue&type=script&lang=js&"
import style0 from "./changepwd.vue?vue&type=style&index=0&id=35cd9e82&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35cd9e82",
  null
  
)

export default component.exports